import styled from "styled-components";
import {Result} from "antd";

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  
`;

export const Layout = styled.div`
  //position: absolute;
  //top: 0;
  //left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0 10px;
`

export const Button = styled.button`
  background: url(//img.smxj.webgame.niuximg.com/acts/sxdvip/img/btn_get.png) no-repeat;
  color: #fef742;
  display: block;
  width: 162px;
  height: 58px;
  line-height: 50px;
  font-size: 18px;
  font-weight: 700;
  margin: 12px auto 0;
  border: none;
  cursor: pointer;
`;

export const Highlight = styled.span`
    color: red;
`;

export const ActivateLayout = styled.div`
    
`;
export const VerifyResult = styled(Result)`
  .ant-result-title {
    font-size: 20px;
  }
`